<template>
  <div>
    <div ref="turnstileContainer" class="turnstile-container"></div>
    <div v-if="status === 'loading'" class="text-sm text-gray-500">Memuat verifikasi keamanan...</div>
    <div v-if="status === 'error'" class="text-sm text-red-500">Gagal memuat keamanan. Silakan refresh.</div>
  </div>
</template>

<script>
export default {
  name: 'Turnstile',
  props: {
    sitekey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      widgetId: null,
      status: 'loading', // loading, ready, error
      scriptId: 'cf-turnstile-script'
    };
  },
  mounted() {
    console.log('[Turnstile] Mounted');
    this.ensureTurnstileLoaded();
  },
  beforeDestroy() {
    if (this.widgetId && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  },
  methods: {
    ensureTurnstileLoaded() {
      // 1. Check if global object exists
      if (window.turnstile) {
        console.log('[Turnstile] window.turnstile found');
        this.renderWidget();
        return;
      }

      // 2. Check if script is already present but not loaded
      if (document.getElementById(this.scriptId)) {
         console.log('[Turnstile] Script tag exists, waiting...');
         this.waitForTurnstile();
         return;
      }

      // 3. Inject Script dynamically
      console.log('[Turnstile] Injecting script');
      const script = document.createElement('script');
      script.id = this.scriptId;
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      
      script.onload = () => {
         console.log('[Turnstile] Script loaded');
         this.waitForTurnstile();
      };
      
      script.onerror = () => {
         console.error('[Turnstile] Script load error');
         this.status = 'error';
         this.$emit('fail');
      };

      document.head.appendChild(script);
    },
    waitForTurnstile(attempts = 0) {
       if (window.turnstile) {
         this.renderWidget();
         return;
       }
       
       if (attempts > 50) { // 5 seconds timeout
         this.status = 'error';
         console.error('[Turnstile] Timeout waiting for window.turnstile');
         return;
       }

       setTimeout(() => {
         this.waitForTurnstile(attempts + 1);
       }, 100);
    },
    renderWidget() {
      if (!this.$refs.turnstileContainer) {
         console.error('[Turnstile] Container missing');
         return;
      }

      try {
        console.log('[Turnstile] Rendering widget...');
        this.widgetId = window.turnstile.render(this.$refs.turnstileContainer, {
          sitekey: this.sitekey,
          appearance: 'interaction-only',
          callback: (token) => {
            console.log('[Turnstile] Challenge Success');
            this.$emit('verify', token);
          },
          'expired-callback': () => {
            console.warn('[Turnstile] Token Expired');
            this.$emit('expire');
          },
          'error-callback': () => {
             console.error('[Turnstile] Widget Error');
             this.status = 'error';
             this.$emit('fail');
          }
        });
        this.status = 'ready';
      } catch (e) {
        console.error('[Turnstile] Render Exception:', e);
        this.status = 'error';
      }
    },
    reset() {
      if (this.widgetId && window.turnstile) {
        window.turnstile.reset(this.widgetId);
      }
    }
  }
};
</script>
<style scoped>
.turnstile-container {
  min-height: 0px;
}
</style>
